import { ParagraphCoinFactory__factory } from "@/util/types/contracts/ParagraphCoinFactory__factory"
import { COIN_FACTORY_ADDRESSES } from "@/util/constants/coins"

export const COIN_FACTORY_ABI = ParagraphCoinFactory__factory.abi
/**
 * The chain ID that coins are deployed on.
 *
 * This is hardcoded to sepolia during testing.
 */
export const CHAIN_ID = 84532
export const COIN_FACTORY_ADDRESS = COIN_FACTORY_ADDRESSES[CHAIN_ID]
export const TX_CHAIN_EXPLORER = "https://sepolia.basescan.org/tx/"

/**
 * These are the PAIR token addresses (eg the pair that a coin is paired with in the pool).
 */
export const TOKEN_ADDRESSES = [
  "0x4200000000000000000000000000000000000006", // WETH
]
